<p>liste-sponsors works!</p>
